/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\option.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


import { ADD_OPTION, REMOVE_OPTION, addOption } from '../actions/option';
import variableReducer from './variable';
import { createVariable } from '../actions/variable';
import { OptionWrapper } from '../../logic/option_wrapper';
import lpApp from '../../app/lp_app';

// TODO: update the conditions after repeating every thing.
export default function optionReducer(state = {}, action) {
  switch (action.type) {
    case ADD_OPTION: {
      const opt = new OptionWrapper(lpApp.references.getOption(action.id));
      // quick test if the father is good
      const par = new OptionWrapper(lpApp.references.getOption(opt.parentId));

      const result = {
        id: opt.id,
        type: opt.type,
        label: opt.label,
        options: opt.children,
        variables: opt.variables,
        multiple: opt.is_multiple,
        papa_multiple: (opt.is_multiple && !par.is_multiple),
      };
      result.variable_renderer = result.variables.map(
        idx => variableReducer({}, createVariable(idx)),
      );
      result.option_renderer = result.options.map(idx => optionReducer({}, addOption(idx)));
      return result;
    }
    case REMOVE_OPTION:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/option.js